import { useEffect, useState, useRef } from "react";
import * as echarts from "echarts";

const DownTimeLostOilAndGas = ({ active, downTimeData }) => {
  const chartRef = useRef(null);
  const chartInstanceRef = useRef(null);

  const [siteNames, setSiteNames] = useState([]);
  const [seriesData, setSeriesData] = useState([]);

  useEffect(() => {
    if (!chartRef.current) return;
    const chart = echarts.init(chartRef.current);
    chartInstanceRef.current = chart;
    chart.setOption({
      label: {
        show: true,
        position: "right",
        distance: 15,
        align: "left",
        verticalAlign: "middle",
        fontSize: 16,
      },
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "shadow",
        },
      },
      xAxis: [
        {
          type: "value",
        },
      ],
      yAxis: [
        {
          type: "category",
          axisTick: { show: false },
          data: [],
        },
      ],
      series: [],
      grid: {
        left: "3%",
        right: "4%",
        bottom: "3%",
        containLabel: true,
      },
      dataZoom: [
        {
          type: "slider",
          yAxisIndex: 0,
          start: 0,
          end: 100,
        },
      ],
    });
    const handleResize = () => {
      chart.resize();
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
      chart.dispose();
    };
  }, []);
  useEffect(() => {
    transformToChartSeries(downTimeData);
  }, []);
  useEffect(() => {
    if (!chartInstanceRef.current) return;
    const chart = chartInstanceRef.current;
    if (siteNames.length === 0 || seriesData.length === 0) {
      console.error("No site names or series data available to update chart");
      return;
    }
    chart.setOption({
      tooltip: {
        trigger: "axis",
        axisPointer: { type: "shadow" },
      },
      legend: {
        data: ["Oil", "Gas"],
      },
      xAxis: {
        type: "value",
      },
      yAxis: {
        data: siteNames,
      },
      series: seriesData.map((series) => ({
        ...series,
        data: series.data.map((value) => (value ? value : 0)),
        label: {
          ...series.label,
          show: true,
        },
      })),
    });
  }, [siteNames, seriesData]);
  useEffect(() => {
    if (active && chartInstanceRef.current) {
      chartInstanceRef.current.resize();
    }
  }, [active]);
  const transformToChartSeries = (dataArray) => {
    if (!dataArray || dataArray.length === 0) {
      console.error("No data available to transform");
      return;
    }
    const grouped = {};
    dataArray.forEach((item) => {
      const siteName = item.siteName;
      const oilValue = parseFloat(item.lostOil.toFixed(2)) || 0;
      const gasValue = parseFloat(item.lostGas.toFixed(2)) || 0;
      if (!grouped[siteName]) {
        grouped[siteName] = { Oil: 0, Gas: 0 };
      }
      grouped[siteName].Oil += oilValue;
      grouped[siteName].Gas += gasValue;
    });
    console.log("object grouped", grouped);

    const siteNames = [...new Set(dataArray.map((item) => item.siteName))]
      .sort()
      .reverse();
    setSiteNames(siteNames);

    const series = grouped[siteNames[0]]
      ? Object.keys(grouped[siteNames[0]]).map((key) => {
          const color =
            key === "Oil" ? "green" : key === "Gas" ? "red" : undefined;
          return {
            name: key,
            type: "bar",
            data: siteNames.map((siteName) =>
              parseFloat(grouped[siteName][key].toFixed(2))
            ),
            itemStyle: {
              color: color,
            },
          };
        })
      : [];

    console.log("series", series);
    setSeriesData(series);
    return;
  };
  return (
    <div
      ref={chartRef}
      style={{ width: "100%", height: "100%", minHeight: "675px" }}
    />
  );
};
export default DownTimeLostOilAndGas;
